var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99383 0.706299C7.22951 0.706299 5.5048 1.22948 4.03782 2.20969C2.57084 3.1899 1.42746 4.5831 0.752285 6.21312C0.0771074 7.84315 -0.09955 9.63678 0.244653 11.3672C0.588855 13.0976 1.43846 14.6871 2.68602 15.9347C3.93359 17.1823 5.52309 18.0319 7.25351 18.3761C8.98394 18.7203 10.7776 18.5436 12.4076 17.8684C14.0376 17.1933 15.4308 16.0499 16.411 14.5829C17.3912 13.1159 17.9144 11.3912 17.9144 9.62688C17.9144 7.261 16.9746 4.99201 15.3016 3.31908C13.6287 1.64614 11.3597 0.706299 8.99383 0.706299ZM8.99383 4.52941C9.18287 4.52941 9.36766 4.58546 9.52483 4.69048C9.68201 4.79551 9.80451 4.94478 9.87685 5.11942C9.94919 5.29407 9.96812 5.48624 9.93124 5.67165C9.89436 5.85705 9.80333 6.02735 9.66967 6.16102C9.536 6.29469 9.3657 6.38572 9.18029 6.4226C8.99489 6.45947 8.80272 6.44055 8.62807 6.36821C8.45343 6.29587 8.30415 6.17336 8.19913 6.01618C8.09411 5.85901 8.03805 5.67422 8.03805 5.48518C8.03805 5.2317 8.13875 4.98859 8.318 4.80935C8.49724 4.6301 8.74034 4.52941 8.99383 4.52941ZM11.5426 14.804H6.44509V13.3703H8.277V9.70653H7.08228V8.27287H9.71066V13.3703H11.5426V14.804Z",
    fill: "#969191"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooltip);
export default __webpack_public_path__ + "static/media/icon-tooltip.3a31898127267ed7dae59ee98d393e92.svg";
export { ForwardRef as ReactComponent };